<footer *ngIf="sag" class="card-footer text-end mx-3">
    <button *ngIf="!sag.locked"
            class="btn btn-success btn-sm ms-1"
            type="button"
            (click)="onLock()">Godkend
    </button>
    <button *ngIf="sag.locked && !sag.lukket"
            class="btn btn-primary btn-sm ms-1"
            type="button"
            (click)="onLock()">Rediger
    </button>
    <button *ngIf="sag.locked && !sag.lukket"
            class="btn btn-success btn-sm ms-1"
            type="button"
            (click)="onCloseCase()">Afslut sag
    </button>
    <button *ngIf="sag.lukket && !sag.faktureret && user.lev >= 4"
            class="btn btn-danger btn-sm ms-1"
            type="button"
            (click)="onReopenCase()">Genåbn sag
    </button>
    <button *ngIf="sag.lukket && !sag.faktureret"
            class="btn btn-success btn-sm ms-1"
            type="button"
            (click)="onInvoiced()">Alt faktureret
    </button>
    <button *ngIf="sag.faktureret && user.lev >= 4"
            class="btn btn-danger btn-sm ms-1"
            type="button"
            (click)="onCancelInvoiced()">Annuller faktureret
    </button>
</footer>
